<template>
  <div class="links-container">
      <div class="links-container-list">
          <h2>Produtos</h2>
          <div :class="`link-box ${selectedProduct && link.id == selectedProduct.id ? 'active' : ''}`" v-bind:key="link.id" v-for="link in links" v-on:click="selectedProduct = link">
              <v-icon class="link-icon">fas fa-{{link.icon}}</v-icon>
              <p>{{ link.title }}</p>
          </div>
      </div>
      <ProductCard v-if="selectedProduct" :link="selectedProduct" />
  </div>
</template>
<script>
  import ProductCard from '../components/ProductCard.vue';

  export default {
      components: { ProductCard },
      data: () => ({
          referralCode: null,
          affiliateKey: null,
          links: [],
          requestStatus: [],
          driveLink: null,
          selectedProduct: null,
      }),

      computed: {
          isMaster() {
              return this.$uCan({key: 'subAfiliados'}) === 1;
          },
      },

      methods: {
          getCardLinks() {
              this.$api.dataService.execute('client/getCardLinks', { pParam: false, platform: 'backoffice', isMaster: this.isMaster })
                  .then(res => {
                      this.links = JSON.parse(JSON.stringify(res));
                  }).catch(err => {
                      //
                  });
          },
      },

      async created() {
          this.requestStatus = await this.$api.dataService.search('requestStatus');
          var res = await this.$api.dataService.execute('client/getReferralCode', { pParam: false });
          if(res){
              this.referralCode = res.referralCode;
              this.affiliateKey = res.affiliateKey;
          }

          this.getCardLinks();
      }
  }
</script>

<style scoped>
  p {
      margin: 0 !important;
  }

  h2 {
      font-size: 28px !important;
      font-weight: bold !important;
      color: #262626;
  }

  .header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
  }

  .links-container {
      width: 100%;
      min-height: calc(100vh - 64px);
      background-color: #EFEFEF;
      padding: 40px;
      padding-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex: 0;
      gap: 15px;
  }

  .links-container-list {
      width: 250px;
      display: flex;
      flex-direction: column;
      gap: 15px;
  }

  .link-box {
      background-color: #FFF;
      color: #262626;
      transition: .2s;
      border-radius: 5px;
      padding: 15px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
      font-weight: bold;
      cursor: pointer;
      user-select: none;
  }

  .link-box.active {
      background-color: var(--primary-color);
      color: white;
  }

  .link-box.active i {
      background-color: #FFF;
  }

  .link-icon {
      width: 30px;
      height: 30px;
      color: #4744e9 !important;
      font-size: 14px !important;
      background-color: #4744e925;
      border-radius: 100px;
  }

  .link-text {
      font-size: 13px;
      color: #5E5E5E;
      line-height: 1.7;
      margin-top: 10px;
      padding: 20px;
      background-color: #e4f6ff;
      color: #5589a3;
      border-radius: 5px;
      font-weight: 500;
  }

  .link-box-footer {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      gap: 10px;
  }

  .link-alert {
      color: #262626;
      margin-top: 25px;
      font-style: italic;
  }

  .link-links {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      padding: 10px 0;
  }

  .link-links > .separator {
      width: 1px;
      height: 100%;
      background-color: #d3d3d3;
  }

  .link-links > a {
      font-size: 14px;
  }

  .button-copy-link, .button-qr-code, .button-banners {
      width: auto;
      background-color: var(--primary-color);
      color: white;
      padding: 10px 15px !important;
      font-weight: bold;
      font-size: 12px !important;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: .5s;
      text-decoration:none;
  }

  .button-copy-link.request {
      background-color: var(--secondary-color-hover);
  }

  .button-copy-link.request:hover {
      background-color: var(--secondary-color);
  }
  
  .button-copy-link:hover, .button-qr-code:hover {
      background-color: var(--primary-color-hover);
  }

  .button-qr-code {
      width: 30px;
      padding: 10px;
      font-size: 12px;
  }

  .link-qrcode {
      color: white !important;
      font-size: 14px !important;
      transition: none !important;
  }

  .v-icon {
      transition: none !important;
  }

  .link {
      margin: 0 !important;
      font-size: 12px;
      text-align: center;
      color: #838383;
  }

  .qr-code {
      margin-top: 25px;
  }

  .modal-container-qrcode {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      background-color: #2626262f;
      z-index: 1000000000000000;
      display: flex;
      justify-content: center;
      align-items: center;
  }

  .modal-container-qrcode.hidden {
      visibility: hidden;
  }

  .modal-container-qrcode.show {
      visibility: visible;
  }

  .modal-content-qrcode {
      height: auto;
      padding: 30px;
      background-color: #FFF;
      border-radius: 10px;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .25);
      display: flex;
      align-items: flex-end;
      justify-content: center;
      flex-direction: column;
  }

  .modal-content-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
  }

  .modal-content-header > h4 {
      color: var(--primary-color);
      font-weight: bold;
  }

  .download-qrcode {
      width: 100%;
      height: 40px;
      background-color: var(--primary-color);
      margin-top: 10px;
      border-radius: 3px;
  }

  @media only screen and (max-width: 768px) {
      .links-container {
          flex-direction: column;
      }

      .links-container-list {
          width: 100%;
      }
  }

</style>


// WEBPACK FOOTER //
// src/pages/Links.vue